export default __webpack_public_path__ + "static/media/arrow.e613826d.svg";